

import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import logo from '../assets/goshortzzlogo.webp';
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import CustomContainer from "./Customsettingscontain";
// import logo from '../assets/currentgoshortzzlogo.png';
import { menuItems } from "../Sidebar/MenuItems";
import tvlogo from '../assets/logoadmin.jpg';

export default function Sidebar({ collapsed, onClose, onToggle, isDrawerOpen, isNarrow }) {
  const navigate = useNavigate();

  // On narrow screens: use drawer-open class instead of collapsed
  const asideClass = isNarrow
    ? `sidebar ${isDrawerOpen ? "drawer-open" : ""}`
    : `sidebar ${collapsed ? "collapsed" : ""}`;

    const showMiniLogo = !isNarrow && collapsed;

  return (
    <>
      {/* Backdrop — shown behind drawer on narrow when open */}
      {isNarrow && isDrawerOpen && (
        <div
          className="sidebar-backdrop active"
          onClick={onClose}
        />
      )}

      <aside className={asideClass}>
        {/* ── Toggle arrow — only on wide screens ── */}
        {!isNarrow && onToggle && (
          <button
            className="sidebar-toggle-arrow"
            onClick={onToggle}
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            <i className={`bi ${collapsed ? "bi-chevron-right" : "bi-chevron-left"}`} />
          </button>
        )}

        <div className="brand">
          <img
            src={showMiniLogo ? tvlogo : logo}
            alt="Shortzz Logo"
            className="login-logo"
          />
          {/* Close ✕ — show in drawer mode OR when sidebar expanded on wide */}
          {(isDrawerOpen || !collapsed) && onClose && (
            <i
              className="bi bi-x sidebar-close-btn"
              onClick={onClose}
            />
          )}
        </div>

      {/* <h4 style={{ color: '#dc7af0ff', fontSize: '16px', textAlign: 'center', marginTop: '-10px' }}>
        GoShortzz
      </h4> */}

      <CustomContainer className="sidebarscroll">
        <nav className="nav">
          <ul>
            <div className="settings">App</div>
            {/* <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <i className="bi bi-house" style={{ fontSize: 18 }}></i>
              <span>Dashboard</span>
            </NavLink>

            <NavLink
              to="/Users"
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <i className="bi bi-people" style={{ fontSize: 18 }}></i>
              <span>Users</span>
            </NavLink>

            <NavLink
              to='/Posts'
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <i className="bi bi-layers" style={{ fontSize: 18 }}></i>
              <span>Posts</span>
            </NavLink>

            <NavLink
              to='/Hashtags'
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <i class="bi bi-hash"></i>
              <span>Hashtags</span>
            </NavLink>

            <NavLink
              to='/Gifts'
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }>
              <i className="bi bi-gift"></i>
              <span>Gifts</span>
            </NavLink>

            <NavLink
              to="/Withdrawal"
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <i class="bi bi-wallet-fill"></i>
              <span>Withdrawals</span>
            </NavLink>

            <NavLink 
            to="/coinpackages"
            className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <i className="bi bi-box-seam"></i>
              <span>Coin Packages</span>
            </NavLink>

            <NavLink 
            to="/restrictions"
            className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <i className="bi bi-shield-lock"></i>
              <span>Restrictions</span>
            </NavLink>


            <NavLink 
             to="/Reports"
             className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <i className="bi bi-exclamation-triangle"></i>
              <span>Reports</span>
            </NavLink>


            <NavLink 
            to="/notifications"
            className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <i className="bi bi-bell"></i>
              <span>Notifications</span>
            </NavLink>

            <NavLink 
            to="/lives"
            className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <i className="bi bi-person-badge-fill"></i>
              <span>Dummy Lives</span>
            </NavLink> */}


            {menuItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                data-tooltip={item.label}
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <i className={`bi ${item.icon}`}></i>
                <span>{item.label}</span>
              </NavLink>
            ))}

          </ul>
        </nav>
        <div className="settings">Settings</div>
        <div className="sidebar-footer">
          <nav className="nav">
            <ul>

              <NavLink
                to="/ReportReasons"
                className={({ isActive }) =>
                  `nav-item ${isActive ? "active" : ""}`
                }
              >
                <i className="bi bi-gear-fill"></i>
                <span>Settings</span>
              </NavLink>

            </ul>
          </nav>
        </div>
      </CustomContainer>
    </aside>
    </>
  );
}

